import {
  useController,
  Control,
  FieldPath,
  FieldValues,
} from "react-hook-form";
import styles from "./Checkbox.module.scss";

interface CheckboxProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label: string;
  disabled?: boolean;
  className?: string;
  onChange?: (value: boolean) => void;
}

const Checkbox = <T extends FieldValues>({
  name,
  control,
  label,
  disabled = false,
  className = "",
  onChange: customOnChange,
}: CheckboxProps<T>) => {
  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
    defaultValue: false as T[FieldPath<T>],
  });

  const isChecked = Boolean(value);

  const handleToggle = () => {
    if (!disabled) {
      const newValue = !value;
      onChange(newValue);
      if (customOnChange) {
        customOnChange(newValue);
      }
    }
  };

  return (
    <div className={`${styles.checkboxContainer} ${className}`}>
      <div
        className={`${styles.checkboxBox} ${isChecked ? styles.checked : ""} ${
          disabled ? styles.disabled : ""
        }`}
        onClick={handleToggle}
        role="checkbox"
        aria-checked={isChecked}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleToggle();
          }
        }}>
        {isChecked && (
          <img
            src={"/assets/images/svg/tick_white.svg"}
            alt="checked"
            className={styles.tickIcon}
          />
        )}
      </div>
      <label className={styles.label} onClick={handleToggle}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
